import { Stack, Typography } from "@mui/material";
import { ResultText, SpousalMaintenanceFieldVisibility, SpousalMaintenanceResult } from "@shared";

import { useTranslation } from "@/translations";

import { TRANSLATION_BASE } from "../SpousalMaintenanceCalculatorDialog.utils";

interface SpousalMaintenanceCalculatorResultProps {
  visibility: SpousalMaintenanceFieldVisibility;
  resultText: ResultText | null;
}

export function SpousalMaintenanceCalculatorResult({
  visibility,
  resultText,
}: SpousalMaintenanceCalculatorResultProps) {
  const { t } = useTranslation();

  return (
    <Stack
      flex={1}
      gap={2}
      aria-live="polite"
      sx={{
        p: 2,
        bgcolor: "grey.50",
        borderRadius: 1,
      }}
    >
      <Typography variant="overline" color="text.secondary">
        {t(`${TRANSLATION_BASE}.calculationTitle`)}
      </Typography>

      {visibility.notMarried ? (
        <Typography color="error.main" sx={{ fontWeight: 600 }}>
          {t("spousalMaintenance.notMarried")}
        </Typography>
      ) : resultText !== null ? (
        <SpousalMaintenanceResult result={resultText} />
      ) : (
        <Typography color="text.secondary">{t(`${TRANSLATION_BASE}.result.empty`)}</Typography>
      )}
    </Stack>
  );
}
